<template>
  <div class="maintenance">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-xl-3">
            <div class="card card-h-100">
              <div class="card-body p-0">
                <div>
                  <div class="creat-btn">
                    <button
                      class="btn btn-primary w-100 mb-3"
                      @click="handleAdd()"
                    >
                      <i class="mdi mdi-plus"></i>
                      新建保养任务
                    </button>
                  </div>
                  <div class="scheduled">
                    <flat-pickr v-model="smCalendarDate" :config="dateConfig">
                    </flat-pickr>
                    <button
                      class="btn w-100 piker-btn"
                      @click="handleToToday()"
                    >
                      今天
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-9">
            <div class="card card-h-100">
              <div class="card-body equipment" style="position: relative">
                <FullCalendar ref="calendar" :options="calendarOptions" />
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <AddForm
      v-if="isShowAddForm"
      :formType="formType"
      :singleData="singleData"
      :date="date"
      v-model:isShowAddForm="isShowAddForm"
      @handleAlert="handleAlert"
      @handleGetTasks="handleGetTasks"
    ></AddForm>
    <EditForm
      v-if="isShowReportForm"
      :formType="formType"
      :singleData="singleData"
      :itemsList="itemsList"
      :date="date"
      v-model:isShowReportForm="isShowReportForm"
      @handleAlert="handleAlert"
      @handleGetTasks="handleGetTasks"
      @handleEdit="handleEdit"
      @handleDelete="handleDelete"
      @changeStatus="changeStatus"
    ></EditForm>
    <MessageAlert
      :alertInfo="alertInfo"
      v-if="formValidataAlert"
    ></MessageAlert>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import "@fullcalendar/core/vdom";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import FullCalendar from "@fullcalendar/vue3";
import moment from "moment";
import _ from "loadsh";

import AddForm from "./components/MaintenAddForm.vue";
import EditForm from "./components/MaintenEditForm.vue";
import MessageAlert from "@/components/common/MessageAlert";
import {
  getMaintenTasks,
  getMaintenTaskStatus,
  deleteMaintenTasks,
  updateMaintenTaskStatus,
} from "@/service/index.js";

export default {
  data() {
    return {
      calendarOptions: {
        timeZone: "local",
        locale: "zh",
        plugins: [
          dayGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        themeSystem: "bootstrap",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,listMonth",
        },
        buttonText: {
          today: "今天",
          month: "月视图",
          listMonth: "视图列表",
        },
        customButtons: {
          prev: {
            text: "prev",
            click: () => {
              var da = moment(this.$refs.calendar.getApi().getDate()).subtract(
                3,
                "months"
              ); //当前时间的前3个月时间
              const e = moment(this.$refs.calendar.getApi().getDate())
                .startOf("month")
                .format("YYYY-MM-DD");
              const s = this.moment(da).endOf("month").format("YYYY-MM-DD");
              var movetype = true;
              this.date = {
                s,
                e,
                movetype,
              };
              this.handleGetTasks(this.date);
              this.$refs.calendar.getApi().prev();
            },
          },
          next: {
            text: "next",
            click: () => {
              var da = moment(this.$refs.calendar.getApi().getDate()).add(
                2,
                "months"
              );
              const s = moment(this.$refs.calendar.getApi().getDate())
                .startOf("month")
                .format("YYYY-MM-DD");
              const e = this.moment(da).endOf("month").format("YYYY-MM-DD");
              var movetype = true;
              this.date = {
                s,
                e,
                movetype,
              };
              this.handleGetTasks(this.date);
              this.$refs.calendar.getApi().next();
            },
          },
          today: {
            text: "今天",
            click: () => {
              const s = this.moment().startOf("month").format("YYYY-MM-DD");
              const e = this.moment().endOf("month").format("YYYY-MM-DD");
              this.date = {
                s,
                e,
              };
              this.handleGetTasks(this.date);
              this.$refs.calendar.getApi().today();
            },
          },
        },
        noEventsContent: "没有要显示的事件",
        windowResize: () => {
          this.getInitialView();
        },
        initialView: this.getInitialView(),
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        dateClick: this.dateClicked,
        eventClick: this.editEvent,
        events: [],
        eventDidMount: (info) => {
          if (
            info.view.type === "dayGridMonth" &&
            info.event._def.extendedProps.status == 1
          ) {
            let titleEl = info.el.getElementsByClassName("fc-event-title")[0];
            let dotEl = info.el.getElementsByClassName(
              "fc-daygrid-event-dot"
            )[0];
            titleEl.style.textDecoration = "line-through";
            titleEl.style.opacity = "0.5";
            dotEl.style.opacity = "0.5";
          }
          if (info.view.type == "listMonth") {
            let btn = document.createElement("td");
            let i = document.createElement("i");
            btn.append(i);
            if (info.event._def.extendedProps.status === 1) {
              i.className =
                "statusbtn fs-20 ri-checkbox-circle-fill text-success";
              let titleEl = info.el.getElementsByClassName(
                "fc-list-event-title"
              )[0];
              let dotEl =
                info.el.getElementsByClassName("fc-list-event-dot")[0];
              titleEl.style.textDecoration = "line-through";
              titleEl.style.opacity = "0.5";
              dotEl.style.opacity = "0.5";
            } else {
              i.className =
                "statusbtn fs-20 ri-checkbox-circle-fill text-muted";
            }
            btn.style.height = "30px";
            btn.style.width = "30px";
            btn.style.zIndex = "9999";
            btn.style.cursor = "pointer";
            btn.addEventListener("click", this.changeTypeclick, true);
            info.el.append(btn);
            let ths = document.querySelectorAll(".fc-list-day th");
            ths.forEach((th) => {
              th.getAttributeNode("colspan").value = 4;
            });
            document.getElementsByClassName("");
          }
        },
      },
      dateConfig: {
        inline: true,
        altFormat: "Y-m-d", //选择时显示的时间
        altInput: false,
        dateFormat: "Y-m-d",
      },
      smCalendarDate: moment().format("YYYY-MM-DD"),
      isShowAddForm: false,
      isShowReportForm: false,
      formType: "add",
      singleData: {},
      alertInfo: {
        content: "",
        variant: "danger",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
    };
  },
  props: {
    equipmentList: {
      type: Array,
      default: () => [],
    },
    itemsList: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    const s = moment().subtract(1, "M").startOf("month").format("YYYY-MM-DD");
    const e = moment().add(1, "M").endOf("month").format("YYYY-MM-DD");
    this.date = {
      s,
      e,
    };
    this.handleGetTasks(this.date);
  },
  methods: {
    /* 日历展示样式问题：
        1.当天创建之前日期的任务，手动点击完成，会创建多个任务
    */
    moment,
    handleGetTasks(date) {
      let params = {
        equipment_id: this.$route.query.equip_id,
        starts: date.s,
        ends: date.e,
      };
      getMaintenTasks(params)
        .then((res) => {
          if (res && _.get(res, ["meta", "code"]) === 0 && res.payload) {
            this.calendarOptions.events = res.payload;
            this.calendarOptions.events.length &&
              this.calendarOptions.events.map((item) => {
                if (item.assignee == null) {
                  item.assignee = "";
                }
                if (item.summary == null) {
                  item.summary = "";
                }
                item.start =
                  item.starts + " " + JSON.parse(item.properties).time;
                item.className = "text-info text-start fs-14";

                if (item.ends) {
                  item.end = item.ends + "";
                }
                if (item.status === 1) {
                  item.className = "text-info text-start fs-14";
                }
              });
          }
        })
        .catch((err) => {
          this.handleAlert("danger", err.message || "请求失败，请重试!");
        });
    },
    getInitialView() {
      if (window.innerWidth <= 768) {
        return "listMonth";
      } else {
        return "dayGridMonth";
      }
    },
    handleEdit(data) {
      this.singleData = _.cloneDeep(data);
      let newItems = [];
      this.singleData.items.forEach((item) => {
        newItems.push(item.name);
      });
      this.singleData.items = newItems;
      this.singleData.originItems = this.singleData.items;
      this.formType = "edit";
      this.isShowAddForm = true;
    },
    handleToToday() {
      this.smCalendarDate = moment().format("YYYY-MM-DD");
    },
    dateClicked(info) {
      let date = moment(info.date).format("YYYY-MM-DD");
      this.handleAdd(date);
    },
    editEvent(info) {
      if (
        this.changepamtype &&
        info.jsEvent.target.classList[0] === "statusbtn"
      ) {
        let statusParams = {
          status: info.event._def.extendedProps.status === 1 ? 0 : 1,
          starts: info.event._def.extendedProps.starts,
        };
        let tastId = info.event._def.publicId;
        this.changeStatus("list", tastId, statusParams);
      } else {
        let data = {
          ...info.event._def.extendedProps,
          id: info.event._def.publicId,
          title: info.event._def.title,
        };
        this.singleData.id = data.id;
        this.singleData.starts = this.datefilters(data.starts);
        this.singleData.maintenance_name = data.title;
        this.singleData.assignee = data.assignee;
        this.singleData.summary = data.summary;
        this.singleData.repeat = data.repeat;
        this.singleData.repeattype = data.repeattype;
        if (data.properties) {
          let properties = JSON.parse(data.properties);
          this.singleData.equipment_id = properties.equipment_id;
          this.singleData.equipment_name = properties.equipment_name;
          this.singleData.items = properties.maintenceItems;
          this.singleData.cycle = properties.cycle;
          this.singleData.cycletype = properties.cycletype;
          this.singleData.num = properties.num;
          this.singleData.status = properties.status;
          this.singleData.ends =
            properties.end_repeat || this.datefilters(data.ends);
          this.singleData.attachments = properties.attachments || [];
        }
        let pam = {
          task_id: data.id,
          starts: this.singleData.starts,
        };
        getMaintenTaskStatus(pam)
          .then((res) => {
            if (res && _.get(res, ["meta", "code"]) === 0 && res.payload) {
              this.singleData.status = res.payload.status;
            }
          })
          .catch((err) => {
            this.handleAlert("danger", err.message || "请求失败，请重试.");
          });
        this.isShowReportForm = true;
      }
    },
    handleDelete(id, type) {
      Swal.fire({
        title: "是否确认?",
        text: "您将无法还原此操作!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          let params = {
            type,
            starts: moment(this.singleData.starts).format("YYYY-MM-DD"),
          };

          deleteMaintenTasks(id, params)
            .then((res) => {
              if (res && _.get(res, ["meta", "code"]) === 0) {
                Swal.fire({
                  text: this.$t('base.delete_success'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: this.$t('base.ok'),
                });
                this.handleGetTasks(this.date);
                // this.getRemainDate("week");
                // this.getRemainDate("month");
                this.isShowReportForm = false;
              }
            })
            .catch((err) => {
              Swal.fire("Failed!", err.message || "删除失败，请重试", "error");
            });
        }
      });
    },
    datefilters(value) {
      value = value + "";
      return (
        value[0] +
        value[1] +
        value[2] +
        value[3] +
        "-" +
        value[4] +
        value[5] +
        "-" +
        value[6] +
        value[7]
      );
    },
    changeStatus(flag, id, params) {
      updateMaintenTaskStatus(id, params)
        .then((res) => {
          if (res && _.get(res, ["meta", "code"]) === 0 && res.payload) {
            this.handleAlert(
              "success",
              "更新成功!",
              "ri-check-double-line",
              1000
            );
            this.handleGetTasks(this.date);
            // this.getRemainDate("week");
            // this.getRemainDate("month");
            if (flag == "list") {
              this.changepamtype = false;
            } else if (flag == "report") {
              this.isShowReportForm = false;
            }
          }
        })
        .catch((err) => {
          this.handleAlert(
            "handleAlert",
            "danger",
            err.message || "请求失败，请重试!"
          );
        });
    },
    handleAdd(date) {
      this.startDate = date || this.smCalendarDate;
      this.singleData = {
        maintenance_name: "",
        equipment_id: this.$route.query.equip_id,
        equipment_name: "",
        items: [],
        cycle: "",
        starts: this.startDate,
        cycletype: null,
        ends: "",
        num: null,
        assignee: "",
        summary: "",
        repeat: "",
        repeattype: "",
        attachments: [],
      };
      this.formType = "add";
      this.isShowAddForm = true;
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.formValidataAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.formValidataAlert = false;
      }, duration);
    },
  },
  components: {
    FullCalendar,
    AddForm,
    EditForm,
    MessageAlert,
  },
};
</script>

<style scoped lang="scss">
:deep(.fc-event) {
  background-color: transparent !important;
  cursor: pointer !important;
  .fc-daygrid-event-dot {
    display: block !important;
    border-color: #3788d8 !important;
  }
  .fc-event-title {
    flex-grow: 0 !important;
  }
  .fc-event-time,
  .fc-list-event-time {
    display: none !important;
  }
}
:deep(.fc) {
  td {
    vertical-align: middle !important;
  }
  .fc-list-event-title a {
    color: #212529 !important;
  }
}
:deep(.fc-list-day-cushion) {
  background: rgba(53, 119, 241, 0.1);
  a {
    color: #299cdb;
  }
}

.scheduled {
  .flatpickr-input {
    display: none;
  }
  .flatpickr-months {
    display: none !important;
  }
}
.piker-btn {
  background-color: #fff;
  border-top: 1px solid #e9ebec;
  color: #6691e7;
}
.creat-btn {
  padding: 10px 10px 0;
}
</style>
